import { render, staticRenderFns } from "./CompanyRoles.vue?vue&type=template&id=03c6cb89&scoped=true"
import script from "./CompanyRoles.vue?vue&type=script&lang=js"
export * from "./CompanyRoles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c6cb89",
  null
  
)

export default component.exports